// API Types

export interface FolderData {
  [year: string]: {
    [month: string]: string[];
  };
}

export interface ApiParams {
  type: string;
  query: string;
  page?: number;
  limit?: number;
}

export interface ApiError {
  message: string;
  code?: string;
  details?: unknown;
}

export interface SSEMessage {
  status: string;
  message: string;
  progress?: number;
  [key: string]: unknown;
}

export type ApiCallback<T> = (response: T | null, error: Error | null) => void;

export class ApiRequestError extends Error {
  public readonly code?: string;
  public readonly details?: unknown;

  constructor(message: string, code?: string, details?: unknown) {
    super(message);
    this.name = 'ApiRequestError';
    this.code = code;
    this.details = details;
  }
}

// 노래 추적 관련 타입
export interface SongMetadata {
  id: string;                 // 구글 드라이브 파일 ID
  artist: string;
  title: string;
  folder: string;
  duration?: number;
  created_at?: string;
  file_hash?: string;         // MD5 해시
  mail_id?: string;           // 메일 고유 ID
  mail_date?: string;         // 메일 수신 날짜
  original_filename?: string; // 원본 파일명
}

export interface MailCheckResponse {
  data: SongMetadata[];
  count: number;
  error?: string;
}

export interface HashCheckResponse {
  exists: boolean;
  data?: SongMetadata;
  error?: string;
}

export interface RefreshCandidate {
  date: string;
  mail_count: number;
  attachment_count: number;
  uploaded_count: number;
  pending_count: number;
}

export interface RefreshScanResponse {
  dates: RefreshCandidate[];
  count: number;
  error?: string;
}
